import React from 'react'
import Summariy from '../component/Summariy'
import Result from '../component/Result'

function Index() {
  return (
    <>
        <div>
          <div className='container'>
           
                <div className="row align-items-center">
                    <Result />
                    <Summariy />
                                    
                </div>
            </div>
        </div>
        
    </>
  )
}

export default Index